import {ActionReducer, ActionReducerMap, MetaReducer} from '@ngrx/store';
import {environment} from '../../../environments/environment';

export interface ProleisSuppliersState {

}

export const reducers: ActionReducerMap<ProleisSuppliersState> = {};

export const metaReducers: MetaReducer<ProleisSuppliersState> [] = !environment.production ? [logger] : [];

export function logger(reducer: ActionReducer<ProleisSuppliersState>): ActionReducer<ProleisSuppliersState> {
  return (state: ProleisSuppliersState, action: any): ProleisSuppliersState => {
    console.log('state', state);
    console.log('action', action);

    return reducer(state, action);
  };
}
